<div style="padding-top: 81px;" id="top">
  <p-table 
    #dt1 
    [columns]="cols" 
    [value]="userList" 
    [tableStyle]="{ 'width': '75%', 'margin-left': 'auto', 'margin-right': 'auto'}" 
    styleClass="p-datatable-striped p-datatable-gridlines"
    dataKey="id"
    selectionMode="single"
    [(selection)]="selected"
    [paginator]="true"
    [rows]="10"
    responsiveLayout="stack" 
    [breakpoint]="'500px'"
    [showCurrentPageReport]="true"
    [loading]="loading"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"

    class="bg-white"
  >
    <ng-template pTemplate="caption">
      <div class="title">{{ "users" | translate }}</div>
      <div class="relative mb-3">
        <input
          #userSearchInput
          pInputText
          style="float: left; margin-left: 12.5%; width: 25%; background-color: var(--list-bg-color); color: var(--text-color); -webkit-transition: 0s; transition: 0s;"
          type="text"
          placeholder="Search"
          (input)="dt1.filterGlobal($any($event.target).value, 'contains')" 
          class="pl-3 pr-3 border border-gray-300 focus:border-blue-500 h-10 outline-none font-sans text-lg font-light"
        >
        <i class="pi pi-search object-right items-center -ml-6 text-gray-400 mt-3"></i>
        <button
          style="color: #1f6873; font-family: Noto Sans JP; margin-left: 25px;"
          (click)="clearSearch(userSearchInput, dt1)"
        >
          {{ "clear" | translate }}
        </button>
        <button
          style="float: right; margin-right: 12.5%; width: 145px"
          class=" items-center justify-center text-center button w-40 h-10 rounded text-lg cursor-pointer"
          (click)="jumpCreateUser()"
        >
          {{"addUser" | translate}}
        </button>
      </div>
      <div class="header-area">
        <span>Name & Company</span>
        <span>Email</span>
        <span>Phone Number</span>
      </div>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr [pSelectableRow]="rowData" style="border: 1px solid var(--list-border-color); background-color: #ffffff; cursor: auto;">
        <td class="truncate font-sans text-sm flex">
          <div style="height: 59px; width: 59px; display: flex; margin-right: 10px; align-items: center;">
            <div style="height: 59px; width: 59px;">
              <img 
                src="../../assets/images/user-profile-image.png" 
                style="height: 59px; width: 59px; object-fit: contain; border-radius: 8%;" 
              />
            </div>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1.5fr; gap: 10px; width: calc(100% - 69px)">
            <div style="overflow: hidden; text-overflow: ellipsis; justify-content: left;">
              <div class="user-name"> 
                {{rowData.name}} 
              </div>
              <div class="company-name" style="margin-top: 3px"> 
                {{rowData.cmn_company.name}} 
              </div>
              <div class="company-name"> 
                {{rowData.position}} 
              </div>
            </div>
            <div style="padding-top: 20px; overflow: hidden; text-overflow: ellipsis; justify-content: left; color: var(--text-color-gray);"> 
              {{rowData.email}}
            </div> 
            <div style="padding-top: 20px; overflow: hidden; text-overflow: ellipsis; justify-content: left; color: var(--text-color-gray);"> 
              {{rowData.telephone}}
            </div>
            <div class="right-area">
              <button style="font-size: 14px; color: #1f6873; font-weight: bold;" (click)="onButtonClick(rowData)"> 
                {{"viewProfile" | translate}}
              </button> 
              <div style="font-size: 12px; color: var(--text-color-gray);"> 
                Updated {{rowData.updatedAt.replace('T', ' ').replace('Z', '').slice(0, 16)}} UTC
              </div> 
            </div>
          </div>
        </td>
      </tr>
      <br>
    </ng-template>
  </p-table>
</div>